import React, { useState } from 'react';
import { Box, Button, Paper, InputAdornment, Skeleton, FormControlLabel, Switch } from '@mui/material';
import { FormInputDate } from 'components/common';
import { Input } from 'components/layout';
import { useUser } from 'components/hooks';
import { searchbarPolicies } from 'helpers';
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';


const useStyle = makeStyles((theme) => ({
  searchBar: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    alignItems: 'flex-end'
  },
  searchBarBox: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  searchBarBoxTextField: {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    borderRadius: theme.spacing(2)
  }
}));

export default function SearchBarBox({
  onSubmit,
  options,
  methods,
  hideProject=false,
  hideSearch=false,
  hideDate=true,
  hideMacro=true,
  loading=false,
  searchValue = ''
}) {
  const classes = useStyle();
  const [t] = useTranslation();
  const [rotateIcon, setRotateIcon] = useState(false);
  const { getValues, control, handleSubmit } = methods;
  const [macro, setMacro] = useState(false);
  const { user, initParameters } = useUser();

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13)
      onSubmit({ 
        search: getValues('search'), 
        project: macro ? "#MACRO#" : getValues('project') 
      });
  };
  
  const submitMacro = () => {
    onSubmit({ 
      search: getValues('search'), 
      project: macro ? "#MACRO#" : getValues('project') 
    });
  }

  const handleChange = (event) => {
    setMacro(event.target.checked);
  };

  React.useLayoutEffect(() => {
    initParameters({ query: { user: user.username }});
  }, []);

  return (
    <>
      { loading ?
        (
          <Skeleton height="96px" variant="rounded" animation="wave"/>
        )
        :(
          <Paper className={classes.searchBar}>
            {!hideSearch && (
              <Box component="div" className={classes.searchBarBox}>
                <Input
                  {...searchbarPolicies.search}
                  onKeyDown={handleOnKeyDown}
                  control={control}
                  onFocus={() => setRotateIcon(true)}
                  onBlur={() => setRotateIcon(false)}
                  className={classes.searchBarBoxTextField}
                  sx={{ width: '100%' }}
                  InputProps={{ startAdornment: (
                      <InputAdornment position='start'>
                        <SearchIcon sx={{
                          transform: rotateIcon ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
                          transition: '.3s'
                        }}/>
                      </InputAdornment >
                    )
                  }}
                  defaultValue={(searchValue || '' )}
                />
              </Box>
            )}

            {!hideDate && (
              <>
                <FormInputDate
                  id='dateFrom'
                  name='dateFrom'
                  label={'common.components.dateFromLabel'}
                  control={control}
                />
                <FormInputDate
                  id='dateTo'
                  name='dateTo'
                  label={'common.components.dateToLabel'}
                  control={control}
                />
              </>
            )}

            {!hideProject && (
              <Box component="div" sx={{position: 'relative'}}>
                {!hideMacro?
                <Box component="div" sx={{
                  position: 'absolute',
                  right: '0px',
                  marginTop: '-5px'
                }}>
                  <FormControlLabel control={<Switch checked={macro} onChange={handleChange} control={control} id='macro'
                  name='macro' />} label={t('common.components.macroSwichLabel')} />
                </Box>:null}
                <Input
                  {...searchbarPolicies.project}
                  disabled={macro}
                  control={control}
                  options={options}
                  sx={{ minWidth: '300px' }}
                  onChange={handleSubmit(onSubmit)}
                />
              </Box>
            )}

            <Box component="div">
              <Button onClick={macro ? submitMacro : handleSubmit(onSubmit) } variant="contained" size="medium">
                {t('common.components.buttons.search')}
              </Button>
            </Box>
          </Paper>
        )
      }
    </>
  );
}
